export const PAGE_VIEW = 'PageView';
export const NO_CTA_ID = '';
